export default {
      id: "common__reports-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__reports",
      toString: function () {
        return this.url;
      }
    }